import { EventEmitter } from 'eventemitter3';
import { setSelectedAuthorizationScope } from './user-authorization-scopes-store';
const getLocalOrg = () => {
    try {
        const storedOrganization = localStorage.getItem('selectedOrganization');
        return storedOrganization ? JSON.parse(storedOrganization) : undefined;
    }
    catch (e) {
        console.log('json parse for selectedOrganization failed', e);
        return undefined;
    }
};
const createUserAuthorizationStore = () => {
    let userAuthorization = { organization: getLocalOrg(), organizations: [] };
    if (userAuthorization.organization) {
        setSelectedAuthorizationScope(userAuthorization.organization.id);
    }
    const eventEmitter = new EventEmitter();
    return {
        getSnapshot: () => userAuthorization,
        subscribe: (callback) => {
            eventEmitter.addListener('update', callback);
            return () => {
                eventEmitter.removeListener('update', callback);
            };
        },
        setOrganization: (organization) => {
            userAuthorization = { ...userAuthorization, organization };
            eventEmitter.emit('update');
        },
        setOrganizations: (organizations) => {
            userAuthorization = { ...userAuthorization, organizations };
            eventEmitter.emit('update');
        },
        getOrganization: () => userAuthorization.organization,
    };
};
export const authorizationStore = createUserAuthorizationStore();
export const setAuthorizationOrganization = (authorizationOrganization) => {
    console.log('Setting Authorization Organization:', authorizationOrganization);
    authorizationStore.setOrganization(authorizationOrganization);
    const storedOrganization = JSON.parse(localStorage.getItem('selectedOrganization'));
    if (storedOrganization !== authorizationOrganization) {
        localStorage.setItem('selectedOrganization', JSON.stringify(authorizationOrganization));
    }
    console.log(authorizationOrganization);
    setSelectedAuthorizationScope(authorizationOrganization.id);
    console.log('Authorization Organization Set:', authorizationOrganization);
};
